import logger from "@utils/logger";
import axios from "../lib/axios";

export const TYPES = {
  SET_FEATURES: "SET_FEATURES",
};

export function setFeatures(features) {
  return {
    type: TYPES.SET_FEATURES,
    features,
  };
}

export const getFeatures = () => async (dispatch) => {
  try {
    const res = await axios.get('/features');
    dispatch(setFeatures(res.data));
  } catch (err) {
    logger.error("WIP! Unable to get features.\nDetails :", err);
  }
};
